import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { alpha, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Iconify from 'src/components/iconify';

export default function PlanBadge({ plan, isLocked, variant = 'mini', sx }) {
  const theme = useTheme();

  if (!plan) return null;

  const planUpper = plan.toUpperCase();

  // Define colors and styles per plan tier
  let colors = null;

  if (planUpper === 'STANDARD') {
    colors = {
      bg: alpha(theme.palette.info.main, 0.12),
      text: theme.palette.info.dark,
      border: theme.palette.info.main,
      icon: 'solar:shield-check-bold',
      label: 'Standard',
    };
  } else if (planUpper === 'PREMIUM') {
    colors = {
      bg: alpha(theme.palette.primary.main, 0.12),
      text: theme.palette.primary.dark,
      border: theme.palette.primary.main,
      icon: 'solar:star-bold',
      label: 'Premium',
    };
  } else if (planUpper === 'ENTERPRISE') {
    colors = {
      bg: alpha(theme.palette.common.black, 0.08),
      text: theme.palette.text.primary,
      border: theme.palette.grey[800],
      icon: 'solar:crown-bold',
      label: 'Enterprise',
    };
  } else {
    return null; // Don't render badge for FREE or other unrecognized tiers
  }

  if (isLocked) {
    return (
      <Tooltip title={`Available in ${colors.label} Plan`} placement="top" arrow>
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'text.disabled',
            cursor: 'pointer',
            verticalAlign: 'middle',
            '&:hover': {
              color: colors.text,
            },
            ...sx,
          }}
        >
          <Iconify icon="solar:lock-bold" width={14} height={14} />
        </Box>
      </Tooltip>
    );
  }

  return null;
}

PlanBadge.propTypes = {
  plan: PropTypes.string,
  isLocked: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'mini']),
  sx: PropTypes.object,
};
